module.exports = (__parcel__import__("5Pe8r")).then(() => parcelRequire('g36Vt'));